<template>
  <card>
    <div v-if="$store.state.navs[$options.name]">
      <radio-list :name="'status-filter'" :items="rubrics" v-model="rubric" />
      <products v-if="loaded[1] === true" v-show="rubric == 1" />
      <brands v-if="loaded[2] === true" v-show="rubric == 2" />
      <categories v-if="loaded[3] === true" v-show="rubric == 3" />
      <names v-if="loaded[4] === true" v-show="rubric == 4" />
      <labels v-if="loaded[5] === true" v-show="rubric == 5" />
      <categories-group v-if="loaded[6] === true" v-show="rubric == 6" />
      <brands-group v-if="loaded[7] === true" v-show="rubric == 7" />
      <colors v-if="loaded[8] === true" v-show="rubric == 8" />
      <features v-if="loaded[9] === true" v-show="rubric == 9" />
      <feature-values v-if="loaded[10] === true" v-show="rubric == 10" />
      <groups v-if="loaded[11] === true" v-show="rubric == 11" />
    </div>
  </card>
</template>
<script>
export default {
  name: "ProductsPage",
  components: {
    RadioList: () => import("../components/Filters/RadioList"),
    Products: () => import("../components/Products/Products"),
    Brands: () => import("../components/Products/Brands"),
    Features: () => import("../components/Products/Features"),
    Groups: () => import("../components/Products/Groups"),
    FeatureValues: () => import("../components/Products/FeatureValues"),
    Categories: () => import("../components/Products/Categories"),
    Names: () => import("../components/Products/Names"),
    Colors: () => import("../components/Products/Colors"),
    Labels: () => import("../components/Products/Labels"),
    CategoriesGroup: () => import("../components/Products/CategoriesGroup"),
    BrandsGroup: () => import("../components/Products/BrandsGroup"),
  },
  created() {
    if (this.$store.state.navs[this.$options.name]) this.getRubrics();
  },
  methods: {
    getRubrics() {
      this.$http
        .get(`products/navigation`)
        .then((response) => {
          this.rubrics = response.data;
        })
        .catch(() => {})
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
            this.loading = false;
          }, 400);
        });
    },
  },
  watch: {
    rubric(val) {
      this.loaded[val] = true;
    },
  },
  data() {
    return {
      rubrics: [],
      rubric: 1,
      loaded: {
        1: true,
      },
    };
  },
};
</script>
<style>
</style>
